export enum ConnectorNames {
	Coinbase = 'Coinbase',
	MetaMask = 'MetaMask',
	None = 'None',
}
